import { addDays, endOfDay, startOfDay, getTimestamp } from 'owa-datetime';
import { AgendaItem } from 'mini-agenda';
import { CalendarEventKey } from 'mini-calendar-event-types';
import { DAYS_TO_FETCH } from './agendaConstants';
import { ScrollDirectionType } from 'mini-infinite-scroll';
import {
    CalendarEventKeyRange,
    createCalendarEventKey,
    convertEpochTimeToDisplayDate,
} from 'mini-calendar-events-store';

/**
 * Generates the agenda keys based on scroll direction.
 * @param agendaItems Existing agenda items
 * @param scrollDirection The scroll direction of the agenda
 */
export default function getAgendaKeysRangeToRequestForScroll(
    agendaItems: AgendaItem[],
    scrollDirection: ScrollDirectionType,
    deltaDays: number = DAYS_TO_FETCH
): CalendarEventKeyRange {
    let startTimeStampKey: CalendarEventKey = null;
    let endTimeStampKey: CalendarEventKey = null;
    let includeEnd: boolean = false;

    if (agendaItems && agendaItems.length && scrollDirection) {
        if (scrollDirection === ScrollDirectionType.DOWN) {
            // This means the start_key needs to be some days in past.
            const firstAgendaItem = agendaItems[0];
            const existingStartTimeStamp = firstAgendaItem.timestamp;
            startTimeStampKey = createCalendarEventKey(
                getTimestamp(
                    startOfDay(
                        addDays(convertEpochTimeToDisplayDate(existingStartTimeStamp), -deltaDays)
                    )
                ),
                null /*itemId is null */
            );

            endTimeStampKey = createCalendarEventKey(
                firstAgendaItem.timestamp,
                firstAgendaItem.event && firstAgendaItem.event.ItemId.Id
            );
            includeEnd = false; // we do not need to have the end also
        } else {
            // This means the endKey needs to be some days in future.
            const lastAgendaItem = agendaItems[agendaItems.length - 1];
            const existingEndTimeStamp = lastAgendaItem.timestamp;
            endTimeStampKey = createCalendarEventKey(
                getTimestamp(
                    endOfDay(
                        addDays(convertEpochTimeToDisplayDate(existingEndTimeStamp), deltaDays)
                    )
                ),
                null
            );
            startTimeStampKey = createCalendarEventKey(
                existingEndTimeStamp,
                lastAgendaItem.event && lastAgendaItem.event.ItemId.Id
            );
        }
    }

    return { start: startTimeStampKey, end: endTimeStampKey, includeEnd: includeEnd };
}
